import { Button, Modal } from '@repo/ui';
import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { ArrowRightIcon } from '@repo/icons';

interface Props {
  testId: TestId;
  continuing: boolean;
  onShowExisting: () => void;
  onContinueAnyway: () => void;
}

export default function PendingReservationExistsModal({ testId, continuing, onShowExisting, onContinueAnyway }: Props) {
  const handleOpenChange = (open: boolean) => {
    if (!open) onContinueAnyway();
  };

  return (
    <Modal
      open
      testId={testId}
      title={tr('reservations:pending_exists_modal.title')}
      width="md"
      dismissableOnClickOutside={false}
      onOpenChange={handleOpenChange}
      footer={
        <div className="flex gap-2">
          <Button
            testId={testId.append('showExisting')}
            label={tr('reservations:pending_exists_modal.show_existing')}
            color="secondary"
            className="w-full"
            onClick={onShowExisting}
          />
          <Button
            testId={testId.append('continueAnyway')}
            label={tr('reservations:pending_exists_modal.continue_anyway')}
            color="brand"
            className="w-full"
            rightIcon={ArrowRightIcon}
            pending={continuing}
            onClick={onContinueAnyway}
          />
        </div>
      }
    >
      <div className="text-body pt-4 text-base leading-5 font-light">
        {tr('reservations:pending_exists_modal.body')}
      </div>
      <div className="text-body pt-3 pb-4 text-sm leading-5 font-light">
        {tr('reservations:pending_exists_modal.disclaimer')}
      </div>
    </Modal>
  );
}
